export function userAccessDraft(user) {
  return { role: user.role || "staff", active: user.active === true };
}

export function validateEmployeeInput({ email, password = "", role, active }) {
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim())) throw new Error("Enter a valid employee email.");
  if (!["staff", "admin", "owner", "viewer"].includes(role) || typeof active !== "boolean") throw new Error("Choose a valid role and access status.");
  if (password && password.length < 8) throw new Error("Temporary passwords must contain at least eight characters.");
}

export function normalizeBranding(data = {}) {
  return {
    ...Object.fromEntries(["app", "login", "loading", "print"].map(key => [key, (Object.hasOwn(data, key) ? data[key] : data[`${key}Url`] || data[`${key}Logo`]) || ""])),
  };
}

export function brandingPayload(choices) {
  const logos = Object.fromEntries(["app", "login", "loading", "print"].map(key => {
    const path = String(choices[key] || "").trim();
    if (path && (/^[a-z]+:/i.test(path) || path.startsWith("//")) && !/^https:\/\//i.test(path)) {
      throw new Error("Logo URLs must use HTTPS, or enter a Firebase Storage path.");
    }
    return [key, path || null];
  }));
  return logos;
}

export function iouDueDate(input, now = new Date()) {
  if (!input) {
    const result = new Date(now);
    result.setDate(result.getDate() + 30);
    return result;
  }
  if (!/^\d{4}-\d{2}-\d{2}$/.test(input)) throw new Error("Enter a due date in YYYY-MM-DD format.");
  const [year, month, day] = input.split("-").map(Number);
  const date = new Date(year, month - 1, day, 12);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) throw new Error("Enter a real calendar due date.");
  return date;
}

export function iouAmount(payment, manualAmount) {
  if (!payment || payment.voided || payment.repairClosureLocked || payment.repairClosureId) throw new Error("This payment cannot be repaired.");
  if (!payment.customerId) throw new Error("Payment has no customer.");
  if (payment.iouCreated || payment.iouLedgerId) throw new Error("This payment already has an IOU. Refresh and review its ledger.");
  const amount = manualAmount === undefined ? Number(payment.cashier?.total) - Number(payment.amount) : Number(manualAmount);
  const rounded = Math.round(amount * 100) / 100;
  if (!Number.isFinite(rounded) || rounded <= 0) throw new Error("Enter an IOU amount of at least one cent, or use a payment with an unpaid checkout balance.");
  return rounded;
}
